import apiClient from './mobileAuthService';

/**
 * モバイルPIX連携サービス
 * PIXシステムとの連携設定の取得・更新機能を提供
 */
export const mobilePixRenkeiService = {
  /**
   * PIX連携情報の取得
   * 現在のPIX連携設定情報を取得
   * @returns {Promise<Object>} PIX連携情報
   */
  async getPixRenkei() {
    const response = await apiClient.post('/getPixRenkei', {});
    return response.data;
  },

  /**
   * PIX連携情報の更新
   * PIX連携設定を更新
   * @param {Object} data - 更新するPIX連携データ
   * @returns {Promise<Object>} 更新結果
   */
  async updatePixRenkei(data) {
    const response = await apiClient.post('/updatePixRenkei', data);
    return response.data;
  }
};
